import { CustomStyle } from "../../GlobalTypes";

// -----------------------------------------------------------------Exports---
export const style: CustomStyle = {
  paper: {
    padding: 32,
  },
  title: {
    marginBottom: 32,
  },
  subTitle: {
    marginTop: 32,
    marginBottom: 16,
  },
  gridLabel: {
    fontWeight: 600,
    fontSize: 18,
  },
  helper: {
    fontSize: 12,
    color: "gray",
  },
  switchGrid: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  buttonContainer: {
    maxWidth: "none",
    justifyContent: "flex-end",
    display: "flex",
    gap: 16,
    marginBottom: 16,
    marginTop: 64,
    padding: 0,
  },
};
